import { TranslationsContext } from '@teliaee/telia-translate';
import React, { useContext } from 'react';
import { SwitchLink } from './types';
import LoginButton from '../../sso/LoginButton';
import LoginAnchor from '../../sso/LoginAnchor';

interface SwitchPacketLinkProps {
  switchLink?: SwitchLink;
  className?: string;
}

const SwitchPacketLink: React.FC<SwitchPacketLinkProps> = (props) => {
  const { translate } = useContext(TranslationsContext);
  const { switchLink, className } = props;

  if (!switchLink || !switchLink.url) {
    return null;
  }

  if (className === 'btn') {
    return <LoginButton submitDataGa={switchLink.ga} url={switchLink.url} text={switchLink.text || translate('packetItem.switch')} />;
  }

  return <LoginAnchor submitDataGa={switchLink.ga} url={switchLink.url} text={switchLink.text || translate('packetItem.switch')} />;
};

export default SwitchPacketLink;
